import { FC } from 'react';
import { HeaderWaffleMenuTitleProps } from './types';
import { CatHeading } from '@blocks-react/components/Heading';
import cx from 'classnames';

import styles from './HeaderWaffleMenuTitle.module.scss';

export const HeaderWaffleMenuTitle: FC<HeaderWaffleMenuTitleProps> = ({
  title,
}) => {
  return (
    <CatHeading variant="title">
      <span
        className={cx('text-capitalize', styles['header__waffle-menu-title'])}
        data-testid="cat-waffle-menu-title"
      >
        {title}
      </span>
    </CatHeading>
  );
};
